import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAppointmentStatusQuickInfo extends Layout {
    sourceAppointmentStatus: DataSource;
    textboxAppStatus2: Textbox;
    textboxAppStatus: Textbox;
}
